<template>
    <div id="app">
        <Spinner></Spinner>
        <ComposeModal></ComposeModal>
        <Header/>
        <div id="trs-wrapper">
            <router-view/>
            <Footer/>
        </div>
    </div>
</template>
<script>
    /**
     * @author HungNS
     */
    import Header from "@/components/common/app/Header.vue";
    import Footer from "@/components/common/app/Footer.vue";
    import InAppBrowserMixins from "@/common/mixins/InAppBrowserMixins";
    import * as HEADER_TYPE from "@/store/modules/header/type";
    import * as NEWS_TYPE from "@/store/modules/news/type";
    import {createNamespacedHelpers} from "vuex";
    import ServiceUtils from "@/common/utils/ServiceUtils";
    const {mapActions: mapHeaderActions} = createNamespacedHelpers("header");
    const { mapActions: mapNewsActions} = createNamespacedHelpers("news");


    export default {
        components: {Header, Footer},
        mixins: [InAppBrowserMixins],
        methods: {
            ...mapHeaderActions([HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN]),
            ...mapNewsActions([NEWS_TYPE.FORCE_SET_AGREE_FLG]),
            goToRoute(routeName) {
                this.$router.push({name: routeName});
            },
        },
        created: function () {
            this.$root.$on(this.IConstants.EVENT_NAME.ON_CONFIRM_AGREEMENT_WEBKIT, () => {
                this.inAppBrowserCloseable()
            });
        },
        mounted() {
            this.NestedModalConfirm.cssNestedConfirmModal();
            if (ServiceUtils.detectUnsupportedBrowser()) {
              ServiceUtils.showUnsupportedBrowserModal();
            }
            this.store3rdCustomParams()
        }
    };
</script>
<style>
    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }
</style>
